import { convertKeysToCamelCase } from '../../../helpers/baseHelpers';
import { getHandlePositionByFlowDirection } from '../../../helpers/flowHelper';
import style from '../../../assets/scss/components/designer/nodes/FlowNode.module.scss';
import { Button } from '@conversed/shared/src/central/types/blocks/Button';
import { Handle } from 'react-flow-renderer';
import { splitIntoLines } from '../../../helpers/domHelper';
import { useFlow } from '../../../hooks/flow/flow/useFlow';
import { NodeTitle } from './NodeTitle';

interface IProps {
  data: Button;
}

export const ButtonNode: React.FC<IProps> = ({ data }) => {
  const { buttonText } = data;

  const { node, nodeSeparator, nodeBody } = convertKeysToCamelCase(style);

  const firstLanguage = Object.keys(buttonText)[0];
  const { flowDirection } = useFlow();
  const { start, end } = getHandlePositionByFlowDirection(flowDirection);

  return (
    <div className={node}>
      <Handle type="target" position={start} id="start" />
      <NodeTitle data={data} />
      <hr className={nodeSeparator} />
      <div className={nodeBody}>{splitIntoLines(buttonText[firstLanguage])}</div>
      <Handle type="source" position={end} id="end" />
    </div>
  );
};
